export const COLORS = {
    'none': 'bg-light',
    'red': 'bg-danger text-white',
    'orange': 'bg-warning',
    'green': 'bg-success'
}
